import { render, staticRenderFns } from "./McqQuestionFields.vue?vue&type=template&id=444b69e1&"
import script from "./McqQuestionFields.vue?vue&type=script&lang=js&"
export * from "./McqQuestionFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports